<template>
  <div class="me-container">
    <div class="profile-card" @click="goToProfileDetail">
      <el-avatar :size="60" shape="square" :src="my.avatarUrl" />
      <div class="profile-info">
        <div class="name">我的微信</div>
        <div class="wechat-id">微信号: {{ my.username }}</div>
      </div>
      <i class="el-icon-arrow-right arrow" />
    </div>

    <div class="menu-group">
      <div class="menu-item" @click="handleMenuClick('service')">
        <i class="el-icon-wallet icon-service" />
        <span class="menu-title">服务</span>
        <i class="el-icon-arrow-right arrow" />
      </div>
    </div>

    <div class="menu-group">
      <div class="menu-item" @click="handleMenuClick('collect')">
        <i class="el-icon-star-off icon-collect" />
        <span class="menu-title">收藏</span>
        <i class="el-icon-arrow-right arrow" />
      </div>
      <div class="menu-item" @click="handleMenuClick('album')">
        <i class="el-icon-picture-outline icon-album" />
        <span class="menu-title">朋友圈</span>
        <i class="el-icon-arrow-right arrow" />
      </div>
      <div class="menu-item" @click="handleMenuClick('card')">
        <i class="el-icon-tickets icon-card" />
        <span class="menu-title">卡包</span>
        <i class="el-icon-arrow-right arrow" />
      </div>
    </div>

    <div class="menu-group">
      <div class="menu-item" @click="handleMenuClick('setting')">
        <i class="el-icon-setting icon-setting" />
        <span class="menu-title">设置</span>
        <i class="el-icon-arrow-right arrow" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMe',
  data() {
    return {
      my: null
    }
  },
  created() {
    this.my = this.$store.state.userInfo
  },
  methods: {
    goToProfileDetail() {
      this.$message.info('功能开发中')
    },
    /**
     * 统一处理个人中心菜单点击
     * @param {String} type 菜单类型
     */
    handleMenuClick(type) {
      switch (type) {
        case 'setting':
          // 如果有设置页面，进行路由跳转
          // this.$router.push('/chat/setting')
          this.$message.info('功能开发中')
          break

        case 'album':
          // 跳转到朋友圈/相册
          // this.$router.push('/chat/album')
          this.$message.info('功能开发中')
          break

        case 'service':
          this.$message.info('功能开发中')
          break

        case 'collect':
          this.$message.info('功能开发中')
          break

        case 'card':
          this.$message.info('功能开发中')
          break

        default:
          this.$message.warning('未知操作')
      }
    }
  }
}
</script>

<style scoped>
.me-container {
  background-color: #ededed;
  height: 100%;
}
/* 个人卡片 */
.profile-card {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 24px 16px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background-color 0.1s ease; /* 让变灰和恢复的过程有微小的平滑过渡 */
  user-select: none;
}
.profile-card:active {
  background-color: #e5e5e5; /* 微信经典的点击灰色背景色 */
}
.profile-info {
  flex: 1;
  margin-left: 16px;
}
.profile-info .name {
  font-size: 20px;
  font-weight: bold;
  color: #191919;
  margin-bottom: 6px;
}
.profile-info .wechat-id {
  font-size: 14px;
  color: #7f7f7f;
}
/* 菜单组 */
.menu-group {
  background-color: #fff;
  margin-bottom: 8px;
}
.menu-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}
.menu-item:last-child {
  border-bottom: none;
}
.menu-item:active {
  background-color: #f5f5f5;
}
.menu-item i:first-child {
  font-size: 20px;
  margin-right: 14px;
}
.menu-title {
  flex: 1;
  font-size: 16px;
  color: #191919;
}
.arrow {
  color: #c7c7cc;
  font-size: 14px;
}
/* 图标颜色定制 */
.icon-service { color: #07c160; }
.icon-collect { color: #f4b03e; }
.icon-album { color: #2d8cf0; }
.icon-card { color: #51a0f2; }
.icon-setting { color: #46c11b; }
</style>
